import { TaskQueue } from 'owa-task-queue';
import downloadPersonaPhoto from './downloadPersonaPhoto';
import personaControlStore from '../store/Store';
import getPersonaControlKey from '../utils/getPersonaControlKey';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';

export interface PersonaProps {
    name: string;
    emailAddress: string;
    personaId: string;
    mailboxType: string;
    size: PersonaSize;
}

const MAX_NUM_OF_GET_PERSONA_REQUESTS: number = 3;

/**
 * Initialize the get persona photo task queue.
 * The queue will control how many getPersonaPhoto requests to make at any given point
 */
let getPersonaPhotoQueue = new TaskQueue<PersonaProps>(
    MAX_NUM_OF_GET_PERSONA_REQUESTS,
    downloadPersonaPhotoTask,
    500 /* taskDelay */
);

/**
 * The task that is scheduled to run
 * @param persona the prop bag containing properties required to download persona photo
 */
function downloadPersonaPhotoTask(persona: PersonaProps): Promise<any> {
    let personaControlKey = getPersonaControlKey(
        persona.emailAddress,
        persona.personaId,
        persona.size,
        persona.mailboxType,
        persona.name
    );
    let viewState = personaControlStore.viewStates.get(personaControlKey);
    return downloadPersonaPhoto(viewState);
}

export default getPersonaPhotoQueue;
